import APIManager from "modules/common/apiManager";
import { isAccess } from "modules/common/utils";
import {
  Alert,
  ButtonCommonTheme,
  ControlLabel,
  FormColumn,
  FormControl,
  FormGroup,
  FormWrapper,
  ModalFooter,
  ModalForm,
  ModalFormContainer,
} from "modules/theme";
import Select from "react-select-plus";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { globalStateSelector } from "../../../../../store/selector";
import { debounce } from "../../../../../helpers/common";

const RenderFormGroup = React.memo(({ label, type, ...props }) => (
  <FormGroup>
    <ControlLabel required={props.required}>{label}</ControlLabel>
    <FormControl componentClass={type} type={type} {...props} />
  </FormGroup>
));

class CannedMessageAddEdit extends Component {
  constructor(props) {
    super(props);

    this.mAPI = new APIManager();
    this.state = {
      message: (this.props.editData && this.props.editData.message) || "",
      taglist:
        (this.props.editData &&
          Array.isArray(this.props.editData.tags) &&
          this.props.editData.tags.map((tag) => ({
            label: tag,
            value: tag,
          }))) ||
        [],
      selectedTags:
        (this.props.editData &&
          Array.isArray(this.props.editData.tags) &&
          this.props.editData.tags.map((tag) => ({
            label: tag,
            value: tag,
          }))) ||
        [],
    };
  }

  componentDidMount() {
    if (this.props.editData) {
      this.setState({ disabled: !isAccess(this.props.access, "edit") });
    }
    this.fetchTagList();
  }

  fetchTagList = (search = "", page = 1, limit = 20) => {
    this.mAPI.sendGetAPI(
      `/canned-message/tag-list?page_no=${page}&limit=${limit}&search=${search}`,
      (data) => {
        if (Array.isArray(data.data)) {
          this.setState({
            taglist: data.data.map(({ tag }) => ({ value: tag, label: tag })),
          });
        } else {
          this.setState({
            taglist: [],
          });
        }
      },
      (status, error) => {
        console.error({ status, error });
        Alert.error("Something went wrong");
      }
    );
  };

  resetAllData() {
    this.setState({
      message: "",
      selectedTags: [],
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(message);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  }

  saveData = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    if (this.state.selectedTags.length === 0) {
      return Alert.error("Please select at least one tag");
    }

    this.mAPI.sendPostAPI(
      `canned-message/${(this.props.editData && this.props.editData._id) ||
        ""}`,
      {
        message: this.state.message.trim(),
        tags: this.state.selectedTags.map(({ value }) => value),
      },
      (data) => {
        this.props.clearSearchField();
        if (data) {
          this.resetAllData();
          this.props.closeModal(true);
          Alert.success(
            (data && data.message) ||
              `Canned message ${
                this.props.editData && this.props.editData.id
                  ? "updated"
                  : "created"
              } successfully`
          );
        }
      },
      (errorCode, data) => {
        this.apiResponse(errorCode, data);
      },
      "private",
      undefined,
      this.props.editData ? "PUT" : "POST"
    );
  };

  changeState = (e) => {
    const value =
      e.target.value && !e.target.value.trim() ? "" : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  handleTagChange = (selectedTags) => {
    this.setState({ selectedTags });
  };

  debouncedSearch = debounce(this.fetchTagList, 500);

  /**
   * @param {React.SyntheticEvent} e
   */
  onInputKeyDown = (e) => {
    if (e.target.value.length >= 60) {
      e.preventDefault();
    }
  }

  closeModal = () => {
    this.props.closeModal(false);
  };

  render() {
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={this.saveData}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <FormGroup>
                  <ControlLabel required>Select Tags</ControlLabel>
                  <Select.Creatable
                    multi
                    options={this.state.taglist}
                    onChange={this.handleTagChange}
                    onBlurResetsInput
                    onCloseResetsInput
                    value={this.state.selectedTags}
                    onInputChange={this.debouncedSearch}
                    onInputKeyDown={this.onInputKeyDown}
                    onCreate={(e) => {
                      console.log("handleCreate", e)
                    }}
                    onSelect={e => {
                      console.log("handleSelect", e)
                    }}
                    isValidNewOption={(option) => /^[\w@]+$/.test(option && option.label || "")}
                  />
                </FormGroup>
                <RenderFormGroup
                  resize={false}
                  label="Message"
                  placeholder="Enter message"
                  maxLength={500}
                  autoFocus={true}
                  disabled={this.state.disabled}
                  required
                  id="message"
                  name="message"
                  type="textarea"
                  value={this.state.message}
                  onChange={this.changeState}
                />
              </FormGroup>
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type="greyModalBtn"
            btnStyle="cancel"
            OnClick={this.closeModal}
            size="xl"
          >
            Cancel
          </ButtonCommonTheme>
          {!this.state.disabled && (
            <ButtonCommonTheme
              type="blueModalBtn"
              btnType="submit"
              btnStyle="default"
              size="xl"
              style={{ float: "right" }}
            >
              {this.props.editData && this.props.editData._id
                ? "Update"
                : "Add"}
            </ButtonCommonTheme>
          )}
        </ModalFooter>
      </ModalForm>
    );
  }
}

CannedMessageAddEdit.propTypes = {
  group: PropTypes.array,
};

CannedMessageAddEdit.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  access: globalStateSelector.getPermission(state, "canned-message"),
});

export default connect(stateToProps)(CannedMessageAddEdit);



// WEBPACK FOOTER //
// src/modules/screens/settings/CannedMessages/components/CannedMessageAddEdit.jsx